/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, width = 2, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)


/* CLOSE ICON */
export const CloseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHECK ICON */
export const CheckIcon = ({ size = 12 }) => (
    <Icon size={size} width={3.5}>
        <path d="M20 6 9 17l-5-5" />
    </Icon>
)

/* SEARCH ICON */
export const SearchIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="10.8" cy="10.8" r="6.8" />
        <path d="M20.5 20.5 15.7 15.7" />
    </Icon>
)

/* FILTER ICON — THE PERIOD, THE OPERATORS AND THE GAMES OF THE LIST */
export const FilterIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M3 6h18M6.5 12h11M10 18h4" />
    </Icon>
)

/* EYE ICON — THE ROUND OPENS IN A MODAL */
export const EyeIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
        <circle cx="12" cy="12" r="3" />
    </Icon>
)

/* COPY ICON — THE NUMBER OF A GAME GOES TO THE CLIPBOARD */
export const CopyIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="9" y="9" width="11" height="11" rx="2.5" />
        <path d="M15 5.5A2.5 2.5 0 0 0 12.5 3H6.5A2.5 2.5 0 0 0 4 5.5v6A2.5 2.5 0 0 0 6.5 14" />
    </Icon>
)

/* GIFT ICON — THE SECTION ITSELF */
export const GiftIcon = ({ size = 20 }) => (
    <Icon size={size}>
        <rect x="3" y="8" width="18" height="12.5" rx="2.5" />
        <path d="M3 12.5h18M12 8v12.5" />
        <path d="M12 8S10.5 3.5 8 3.5a2.2 2.2 0 0 0 0 4.5ZM12 8s1.5-4.5 4-4.5a2.2 2.2 0 0 1 0 4.5Z" />
    </Icon>
)

/* TROPHY ICON — A WON ROUND */
export const TrophyIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M7 4h10v5.5a5 5 0 0 1-10 0Z" />
        <path d="M7 5.5H4.5v1.5a3 3 0 0 0 3 3M17 5.5h2.5V7a3 3 0 0 1-3 3" />
        <path d="M9.5 20.5h5M12 14.5v6" />
    </Icon>
)

/* CHIP ICON — THE BONUS BET OF A ROUND */
export const ChipIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <circle cx="12" cy="12" r="3.5" />
        <path d="M12 3.5v3M12 17.5v3M3.5 12h3M17.5 12h3" />
    </Icon>
)

/* JACKPOT ICON — THE POOL OF THE OPERATOR */
export const JackpotIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 3.5 14.2 8l5 .7-3.6 3.5.9 4.9L12 14.8 7.5 17.1l.9-4.9L4.8 8.7 9.8 8Z" />
        <path d="M6 20.5h12" />
    </Icon>
)

/* SAFE ICON — THE CASH BOX OF THE OPERATOR */
export const SafeIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3" y="4.5" width="18" height="15" rx="3" />
        <circle cx="11" cy="12" r="3.5" />
        <path d="M17.5 9.5v5M6.5 19.5v1.5M17.5 19.5v1.5" />
    </Icon>
)

/* CARDS ICON — THE COMBINATION OF A ROUND */
export const CardsIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="8.5" y="4" width="11" height="15" rx="2.5" />
        <path d="M6 6.5 4.6 6.9a2.5 2.5 0 0 0-1.8 3l2.4 8.5a2.5 2.5 0 0 0 3 1.8l1.4-.4" />
    </Icon>
)

/* MULTIPLIER ICON — HOW MANY TIMES THE BET WAS PAID */
export const MultiplierIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M6 6l12 12M18 6 6 18" />
    </Icon>
)

/* PLAYER ICON — HOW MANY PEOPLE STAND BEHIND THE ROWS */
export const PlayerIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="9" cy="8" r="3.6" />
        <path d="M2.8 19.5c0-3.2 2.8-5.2 6.2-5.2s6.2 2 6.2 5.2" />
        <path d="M16.5 5.2a3.4 3.4 0 0 1 0 6.6M18 14.7c2.1.6 3.4 2.2 3.4 4.3" />
    </Icon>
)

/* VIP ICON — A CROWN, THE PLAYER IS MARKED IN Users */
export const VipIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M3 7.5 6.5 11 12 4.5 17.5 11 21 7.5v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
    </Icon>
)

/* TABLE ICON — THE GAME BEHIND A ROUND */
export const TableIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="2.5" y="4.5" width="19" height="12" rx="4" />
        <path d="M8 20h8M12 16.5V20" />
    </Icon>
)

/* STUDIO ICON — THE GROUP OF A TABLE */
export const StudioIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3" y="4.5" width="18" height="12.5" rx="2.5" />
        <path d="M7 21h10M12 17v4" />
    </Icon>
)

/* OPERATOR ICON — WHOSE PLAYER MADE THE BET */
export const OperatorIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 20.5V6.5A2 2 0 0 1 6 4.5h6a2 2 0 0 1 2 2v14" />
        <path d="M14 10.5h4a2 2 0 0 1 2 2v8" />
        <path d="M2.5 20.5h19M7.5 8.5h3M7.5 12.5h3M7.5 16.5h3" />
    </Icon>
)

/* CALENDAR ICON — THE PERIOD OF THE LIST */
export const CalendarIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3.5" y="5" width="17" height="15.5" rx="3" />
        <path d="M3.5 10h17M8.5 3v4M15.5 3v4" />
    </Icon>
)

/* CLOCK ICON — THE MOMENT OF A ROUND */
export const ClockIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5V12l3.5 2" />
    </Icon>
)

/* INFO ICON — THE HINT OF A SECTION */
export const InfoIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 7.6v.6" />
    </Icon>
)

/* HASH ICON — THE NUMBER OF A GAME */
export const HashIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M9.5 3.5 7.5 20.5M16.5 3.5l-2 17M4 8.5h16M3 15.5h16" />
    </Icon>
)

/* LAYERS ICON — HOW MANY ROWS THE FILTER HOLDS */
export const LayersIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 3 21 8l-9 5-9-5Z" />
        <path d="M3 13.5l9 5 9-5" />
    </Icon>
)

/* NET ICON — THE DIFFERENCE BETWEEN THE BETS AND THE PAYOUTS */
export const NetIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M3.5 17.5 9 11l4 4 7.5-8.5" />
        <path d="M15.5 6.5h5v5" />
    </Icon>
)

/* RATE ICON — THE EXCHANGE RATE OF THE CURRENCY */
export const RateIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M6 18 18 6" />
        <circle cx="7.5" cy="7.5" r="2.8" />
        <circle cx="16.5" cy="16.5" r="2.8" />
    </Icon>
)

/* PLUS ICON — A NEW OPERATOR IS CONNECTED TO THE JACKPOT */
export const PlusIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M12 5v14M5 12h14" />
    </Icon>
)

/* EDIT ICON — THE AMOUNTS OF AN OPERATOR ARE CHANGED */
export const EditIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 20h4l10.5-10.5a2.8 2.8 0 0 0-4-4L4 16Z" />
        <path d="M14 6.5 17.5 10" />
    </Icon>
)

/* LINK ICON — THE JACKPOT IS TIED TO AN OPERATOR */
export const LinkIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M10 13.5a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1.7 1.7" />
        <path d="M14 10.5a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1.7-1.7" />
    </Icon>
)

/* SETTINGS ICON — THE JACKPOT OF THE OPERATORS, THE SUPERADMIN ALONE OPENS IT */
export const SettingsIcon = ({ size = 15 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="3.2" />
        <path d="M19.4 14.5a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1v.3a2 2 0 0 1-4 0v-.2a1.6 1.6 0 0 0-2.8-1.1l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0-1.1-2.7H3.3a2 2 0 0 1 0-4h.2a1.6 1.6 0 0 0 1.1-2.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 2.7-1.1V3.3a2 2 0 0 1 4 0v.2a1.6 1.6 0 0 0 2.7 1.1l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0 1.1 2.7h.3a2 2 0 0 1 0 4h-.2a1.6 1.6 0 0 0-1.4 1Z" />
    </Icon>
)
